"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.form = void 0;
var tslib_1 = require("tslib");
var joi_1 = tslib_1.__importDefault(require("joi"));
var types_def_1 = require("./types.def");
exports.form = joi_1.default.object({
    schema: joi_1.default.string(),
    type: joi_1.default.string(),
    id: joi_1.default.string(),
    url: joi_1.default.string(),
    rootFormId: joi_1.default.object({
        id: joi_1.default.string(),
        url: joi_1.default.string()
    }),
    revision: joi_1.default.object({
        id: joi_1.default.string(),
        url: joi_1.default.string()
    }),
    name: joi_1.default.string(),
    displayVersion: joi_1.default.number(),
    description: joi_1.default.string(),
    createdAt: types_def_1.dateDefault,
    updatedAt: types_def_1.dateDefault,
    fields: joi_1.default.array().items(joi_1.default.object({
        id: joi_1.default.string(),
        type: joi_1.default.string(),
        name: joi_1.default.string()
    }))
});
//# sourceMappingURL=form.def.js.map